import { useGetCampaignSteps } from "@/features/campaigns/hooks/useCampaign";
import { useCampaignId } from "@/features/campaigns/hooks/useCampaignId";
import React from "react";
import TimePeriodPill from "../components/TimePeriodPill";
import AnalyticsStepCard from "./AnalyticsStepCard";

const DottedLine = ({ className = "" }) => (
  <div
    className={`flex-1 h-0.5 border-b border-dashed border-gray-400 min-w-0 ${className}`}
  />
);

const SequenceWorkFlowSteps = () => {
  const campaignId = useCampaignId();
  const { data: steps } = useGetCampaignSteps(campaignId, !!campaignId);

  if (!steps?.length) return null;

  // Everything from index 2 onward gets its own row
  const singleSteps = steps.slice(2);

  return (
    <div className="flex flex-col w-full">
      {/* ── Row 1 */}
      <div className="flex flex-col w-full">
        <div className="flex items-center w-full min-w-0">
          {/* Left card*/}
          <div className="shrink-0">
            <AnalyticsStepCard step={steps[0]} />
          </div>

          {steps[1] && (
            <>
              <DottedLine />

              <div className="shrink-0">
                <TimePeriodPill duration={steps[1]?.duration} />
              </div>

              <DottedLine />

              <div className="shrink-0">
                <AnalyticsStepCard step={steps[1]} />
              </div>
            </>
          )}
        </div>
      </div>

      {/* ── Rows 2 */}
      {singleSteps?.map((step, i) => {
        const globalIndex = i + 2;

        return (
          <div key={step?.id ?? globalIndex} className="flex flex-col w-full">
            <div
              className={`flex ${i !== 0 ? "flex-col items-center  max-w-[155px]" : "flex-row items-center"} min-w-0 `}
            >
              {step?.duration && (
                <>
                  <div className="shrink-0">
                    {i !== 0 && (
                      <div className="w-full flex flex-col items-center">
                        <div className="w-px  h-[60px] border-l border-dashed border-gray-400" />
                        <TimePeriodPill duration={step.duration} />
                        <div className="w-px h-[60px] border-l border-dashed border-gray-400" />
                      </div>
                    )}
                  </div>
                </>
              )}

              <div className={`shrink-0 ${i === 0 ? "mt-11" : ""}`}>
                <AnalyticsStepCard step={step} />
              </div>
              {i < 1 && (
                <div className="mt-[50px] w-full">
                  <DottedLine />
                </div>
              )}
              {i === 0 && step?.duration && (
                <div className="flex flex-col items-center">
                  <div className="w-px h-[58px] border-r border-dashed border-gray-400" />
                  <TimePeriodPill duration={step.duration} />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SequenceWorkFlowSteps;
